module.exports = __webpack_public_path__ + "static/media/euro.8c0859e0.svg";